import type { MessageDescriptor } from '@cbhq/i18n';
import { defineMessages } from '@cbhq/i18n';

const messages = defineMessages({
  workspace: {
    id: 'Security.approvalRules.product.workspace',
    defaultMessage: 'Workspace',
    description: 'Product section label for Workspace approval rules',
  },
  developerPlatform: {
    id: 'Security.approvalRules.product.developerPlatform',
    defaultMessage: 'Developer Platform',
    description: 'Product section label for Developer Platform approval rules',
  },
  business: {
    id: 'Security.approvalRules.product.business',
    defaultMessage: 'Business',
    description: 'Product section label for Business approval rules',
  },
  unknownProduct: {
    id: 'Approvals.approvalRequestsDisplay.unknownProduct',
    defaultMessage: 'Unknown product',
    description: 'Fallback approval product name when the operation is unavailable',
  },
});

const PRODUCT_LABEL_MESSAGES: Record<string, MessageDescriptor> = {
  account_management: messages.workspace,
  cdp: messages.developerPlatform,
  shared: messages.business,
};

type FormatProductLabel = (descriptor: MessageDescriptor) => string;

export function getApprovalProductLabel(
  product: string | undefined,
  formatMessage: FormatProductLabel,
): string {
  const message = product ? PRODUCT_LABEL_MESSAGES[product] : undefined;
  return formatMessage(message ?? messages.unknownProduct);
}
